<template>
  <div>
    <el-row style="padding-bottom: 10px" @keyup.enter.native="search">
      <el-col :span="24" class="search-box">
        <span
          ><label>编号：</label>
          <el-input
            class="search-input"
            v-model="query.id"
            placeholder="请输入编号"
          ></el-input>
        </span>
        <span>
          <el-button type="primary" @click="search">搜索</el-button>
        </span>
      </el-col>
    </el-row>
    <page-table
      :data-api="this.api.dealer.agreement"
      :viewable="false"
      keyField="id"
    >
      <el-table-column prop="id" label="编号" width="50"></el-table-column>
      <el-table-column
        prop="languageName"
        label="语言名称"
      ></el-table-column>

      <el-table-column
        v-if="!isMobile()"
        prop="created"
        label="添加时间"
        width="150"
        :formatter="dateFormatter"
      ></el-table-column>
    </page-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      query: {
        id: null,
      },
    };
  },
  created: function () {
    let that = this;
    let query = that.getQuery();
    if (query.id) {
      that.query.id = parseInt(query.id);
    }
  },
  methods: {
    dateFormatter(row, column, cellValue, index) {
      return this.dateFormat("yyyy-mm-dd HH:MM:SS", new Date(cellValue));
    },
    search() {
      let that = this;
      let params = Object.assign(this.getQuery(), this.query);
      params.page = 1;
      this.$router.replace({ query: params }, null, function () {
        that.$router.go(0);
      });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    },
  },
};
</script>

<style scoped>
@media screen and (max-device-width: 960px) {
  .search-input {
    width: 105px;
  }
}
@media screen and (min-device-width: 960px) {
  .search-input {
    width: 150px;
  }
}
.search-box span {
  display: inline-block;
  padding: 2px 2px 2px 0px;
}
.search-box span label {
  display: inline-block;
  width: 55px;
}
</style>


// WEBPACK FOOTER //
// List.vue?7516951d